module.exports = __webpack_public_path__ + "franchise-for_honor-desktop.png";